module.exports = __webpack_public_path__ + "static/img/loading-scan.349169ac.gif";